<template>
  <div>
    <b-tabs vertical pills>
      <b-tab title="Introduction"><ttIntroduction/></b-tab>
      <b-tab title="Simplification"><simplification/></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ttIntroduction from '@/components/tt-introduction'
import simplification from '@/components/simplification'

export default {
  name: 'truth-tables',
  components: {
    ttIntroduction,
    simplification
  }
}
</script>


// WEBPACK FOOTER //
// src/components/truth-tables.vue